import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/PageHeader";
import { Tag } from "lucide-react";
import { EmptyState } from "@/components/EmptyState";

export const Route = createFileRoute("/_auth/tag-bucket/")({
  component: TagBucket,
});

function TagBucket() {
  return (
    <>
      <PageHeader title="Tag Bucket" />
      <main className="h-full overflow-y-auto bg-slate-100 p-6">
        <EmptyState
          title="Tag Bucket"
          description="This page isn't available yet, but it's part of our roadmap. It will allow you to organize and manage your animal tags in one place, making data updates and syncing effortless."
          Icon={Tag}
        />
      </main>
    </>
  );
}
